import { normalize } from 'normalizr';
import { arrayOfChannels } from 'shared/schemas';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import getDefaultChannelDealInfo from 'shared/constants/channel-deal-info';


const ACTIONS = createAsyncActions('SERVER.CHANNELS.LIST');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (options) {

  options = _.merge(
    { paging: { size: 1000 } },
    options
  );

  return function (dispatch, getState) {
    dispatch(START());

    return vodAdapter.lists.list(options)
      .then(
        function (response) {

          const { vodSettings } = getState();
          const data = _.map(response.data, function (data) {
            if (!_.get(data, 'dealInfo.length') && vodSettings) {
              data.dealInfo = getDefaultChannelDealInfo(vodSettings.currency);
            }
            return data;
          });

          response = {
            ...response,
            data: normalize(data, arrayOfChannels),
          };

          dispatch(SUCCESS({}, response));
          return response;
        },

        function (reason) {
          dispatch(FAIL({}, reason, { analytics: { type: 'error', name: 'shared.channels.list' } }));
          return Promise.reject(reason);
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channels/list.js